export default function initBlogShare() {
  const buttons = document.querySelectorAll('[data-blog-share]');

  buttons.forEach((button) => {
    button.addEventListener('click', async () => {
      const url = button.dataset.shareUrl;
      const title = button.dataset.shareTitle;
      const status = button.closest('.blog-article__header')?.querySelector('[data-blog-share-status]');

      try {
        if (navigator.share) {
          await navigator.share({ title, url });
          return;
        }

        await navigator.clipboard.writeText(url);

        if (status) {
          status.textContent = button.dataset.copiedText;
        }

        button.classList.add('is-copied');
        window.setTimeout(() => button.classList.remove('is-copied'), 1600);
      } catch (error) {
        if (error?.name !== 'AbortError' && status) {
          status.textContent = button.dataset.errorText;
        }
      }
    });
  });
}
